import { Panel } from "shared/components/panel/Panel";
import TelaInicialAtivacaoGroupPay from "./ativacaoGroupPay/TelaInicialAtivacaoGroupPay";
import BodyPanel from "shared/components/panel/BodyPanel";
import HeaderPanel from "shared/components/panel/HeaderPanel";
import AbasGroupPay from "./configuracaoGroupPay/AbasGroupPay";
import { UserContext } from "context/UserContext";
import { useContext } from "react";
import { useGetStatusAtivacaoGroupPay } from "hooks/groupPay/useGetStatusAtivacaoGroupPay";
import TelaAtivacaoConcluidaGroupPay from "./ativacaoGroupPay/TelaAtivacaoConcluidaGroupPay";
import { useGetStatusWizardGroupPay } from "hooks/groupPay/useGetStatusWizardGroupPay";
import WizardGroupPay from "shared/components/wizard/WizardGroupPay";

const GroupPay: React.FC = () => {
  const { usuarioLogado } = useContext(UserContext);
  const { data: statusAtivacaoGroupPay } = useGetStatusAtivacaoGroupPay(usuarioLogado.codigoSuporte);
  const { data: wizardData } = useGetStatusWizardGroupPay();

  const statusWizard = wizardData?.payload?.status;
  const mostrarAbasGroupPay = statusWizard === "FIM" || statusWizard === "CONFIGURADO";

  return (
    <Panel headerPanel={<HeaderPanel title="Group Pay" />}>
      <BodyPanel noPadding>
        {statusAtivacaoGroupPay === "CONCLUIDO" && !mostrarAbasGroupPay && <WizardGroupPay />}

        {statusAtivacaoGroupPay === "INATIVO" && <TelaInicialAtivacaoGroupPay />}

        {statusAtivacaoGroupPay === "CONCLUIDO" && mostrarAbasGroupPay && <AbasGroupPay />}

        {statusAtivacaoGroupPay === "EM_ANDAMENTO" && <TelaAtivacaoConcluidaGroupPay />}
      </BodyPanel>
    </Panel>
  );
};

export default GroupPay;
